export default __webpack_public_path__ + "static/beach_back-08ffe41b596f710da60e8f793d16b0df.webp";